import { render } from "./ForceChangePassword.vue?vue&type=template&id=724899ad&scoped=true"
import script from "./ForceChangePassword.vue?vue&type=script&lang=js"
export * from "./ForceChangePassword.vue?vue&type=script&lang=js"

import "../../../assets/css/desktop.css?vue&type=style&index=0&id=724899ad&scoped=true&lang=css"
import "./ForceChangePassword.vue?vue&type=style&index=1&id=724899ad&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-724899ad"

export default script